module.exports = __webpack_public_path__ + "static/media/item4.130a593b.png";